const inAppUserAgents = {
  messenger: /\bFB[\w_]+\/(Messenger|MESSENGER)/,
  facebook: /\bFB[\w_]+\//,
  twitter: /\bTwitter/i,
  line: /\bLine\//i,
  instagram: /\bInstagram/i,
}

export const isIOS = (userAgent: string) => /iPad|iPhone|iPod/i.test(userAgent)
export const isInAppBrowser = (userAgent: string) => {
  for (const [, re] of Object.entries(inAppUserAgents)) {
    if (re.test(userAgent)) {
      return true
    }
  }
  return false
}
